var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPDATE_COMPONENT, UPDATE_FORM } from "../../constants/common";
var formReducer = function (state, action) {
    switch (action.type) {
        case UPDATE_FORM:
            return __assign(__assign({}, state), action.payload);
        case UPDATE_COMPONENT:
            return __assign(__assign({}, state), { components: action.payload });
        default:
            return state;
    }
};
export default formReducer;
//# sourceMappingURL=form-reducer.js.map